import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        authToken: null,
    },
    reducers: {
        setAuthToken: (state, action) => {
            state.authToken = action.payload;
        },
    },
});

export const { setAuthToken } = authSlice.actions;
export default authSlice.reducer;
